import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Form, Input, Switch, Select, Radio, Button, Space } from 'antd';
import { pageFormItemLayout } from '@utils/property';
import { getProjestsTopicsListApi, saveTopicsApi, getTopicsInfoApi, updateTopicsApi } from '@services/Selection';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';
import { workspaceSelectionDeclarationsPath } from '@/layouts/selectionWorkspacePaths';

const { TextArea } = Input;

const Topics = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const topicId = params?.id;
    const [form] = Form.useForm();

    const [selectOpinon, setSelectOpinon] = useState([]);

    const onReset = () => {
        navigate(workspaceSelectionDeclarationsPath(params.pid));
    };

    const goBack = () => {
        navigate(workspaceSelectionDeclarationsPath(params.pid), { state: { ...location.state } });
    };

    useEffect(() => {
        document.title = `${!topicId ? '新增主题' : '编辑主题'}-医评议`;
        getProjestsTopicsListApi({ projectId: params.pid }).then(topics => {
            if (topics.status_code === 200) {
                let allTopics = topics?.data || [];
                allTopics = allTopics.filter(item => item.pid === null);
                setSelectOpinon([...allTopics]);
            }
        });
        if (topicId) {
            getTopicsInfoApi({ id: topicId }).then(res => {
                if (res.status_code === 200) {
                    res.data.pid = res.data.pid === 0 ? undefined : res.data.pid;
                    form.setFieldsValue(res.data);
                }
            });
        }
    }, []);

    const onFinish = value => {
        if (topicId) {
            updateTopicsApi({ ...value, projectId: params.pid, id: Number(topicId), hide: value.hide || false, isPeople: value.isPeople || 0, pid: value.pid === undefined ? 0 : value.pid }).then(res => {
                if (res.status_code === 200) {
                    navigate(workspaceSelectionDeclarationsPath(params.pid));
                }
            });
        } else {
            saveTopicsApi({ ...value, projectId: params.pid, hide: value.hide || false, isPeople: value.isPeople || 0, pid: value.pid === undefined ? 0 : value.pid }).then(res => {
                if (res.status_code === 200) {
                    navigate(workspaceSelectionDeclarationsPath(params.pid));
                }
            });
        }
    };
    return (
        <>
            <PageHeader breadcrumb={[]}>
                <div onClick={goBack} className="back page-header-back-btn">
                    <i className="bi bi-chevron-left" />
                </div>
                <span className="current-title">{!topicId ? '新增主题' : '编辑主题'}</span>
            </PageHeader>

            <div className="page-route-body topics-edit-page">
                <div className="main-content-body">
                    <div className="solution-message-content">
                        <Form {...pageFormItemLayout} form={form} onFinish={onFinish} initialValues={{ isPeople: 0 }}>
                            <Form.Item
                                label="主题名称"
                                name={'name'}
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入主题名称',
                                    },
                                ]}
                            >
                                <Input showCount maxLength={30} placeholder="请输入主题名称" />
                            </Form.Item>
                            <Form.Item label="所属主题分类" name={'pid'}>
                                <Select placeholder="请选择所属主题分类" options={selectOpinon} fieldNames={{ label: 'name', value: 'id' }} />
                            </Form.Item>
                            <Form.Item label="主题类型" name={'isPeople'}>
                                <Radio.Group>
                                    <Radio value={0}>实践类</Radio>
                                    <Radio value={1}>人物类</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label="主题说明" name={'description'}>
                                <TextArea maxLength={200} showCount rows={4} />
                            </Form.Item>
                            <Form.Item label="是否隐藏" name={'hide'} valuePropName={'checked'}>
                                <Switch checkedChildren="是" unCheckedChildren="否" />
                            </Form.Item>

                            <div className="page-form-foot-operations">
                                <Space size="large">
                                    <Button type="primary" size="large" htmlType="submit">
                                        提交
                                    </Button>
                                    <Button type="default" size="large" onClick={onReset}>
                                        取消
                                    </Button>
                                </Space>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Topics;
